import { EdgeCreateSignatureRequestRepository } from '@/modules/auth/infra/repositories'
import { makeSupabaseEdgeHttpClient } from '@/main/factories/http'
import type { CreateSignatureRequest } from '@/modules/auth/use-cases'

export function makeCreateSignatureRequest(): CreateSignatureRequest {
  return new EdgeCreateSignatureRequestRepository(makeSupabaseEdgeHttpClient()).execute
}
